import React, { useState } from 'react'
import { ReactFlowProvider } from '@xyflow/react'
import DepartmentLayout from './departmentLayout'
import Loading from '../../component/loading'
import Aside from '../../component/aside'
import Navbar from '../../component/navbar'

function DepartmentLayoutWithProvider() {
    const [loading, setLoading] = useState(false)
    return (
        <>
            {loading ? <Loading /> : null}
            <div className="container">
                <Aside />
                <main className="main-content" style={{ minHeight: '100vh' }}>
                    <Navbar />
                    <ReactFlowProvider>
                        <DepartmentLayout />
                    </ReactFlowProvider>
                </main>
            </div>
        </>
    )
}

export default DepartmentLayoutWithProvider
